import gql from "graphql-tag";

import DefaultScheduleFiltersFragment from "./DefaultScheduleFiltersFragment";

export default gql`
  fragment InterfacePreferencesFragment on InterfacePreferences {
    activityFormatDescriptionFlexHidden
    activityFormatDescriptionOngoingHidden
    activityFormatDescriptionOneTimeHidden
    activityFormatDescriptionMultiDayHidden
    defaultScheduleFilters {
      ...DefaultScheduleFiltersFragment
    }
  }
  ${DefaultScheduleFiltersFragment}
`;
